import { render, staticRenderFns } from "./bspdevreraporu.vue?vue&type=template&id=33bb6231&scoped=true"
import script from "./bspdevreraporu.vue?vue&type=script&lang=js"
export * from "./bspdevreraporu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bb6231",
  null
  
)

export default component.exports